import { render, staticRenderFns } from "./UserHeading.vue?vue&type=template&id=7e5e20ce&scoped=true&"
import script from "./UserHeading.vue?vue&type=script&lang=js&"
export * from "./UserHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5e20ce",
  null
  
)

export default component.exports